import { format as dfFormat, parseISO } from "date-fns";

const LB_PER_KG = 2.20462;

export function formatWeight(lbValue, prefs, opts = {}) {
  const unit = prefs?.weight_unit || "lb";
  const decimals = opts.decimals ?? 1;
  if (lbValue == null) return `0 ${unit}`;
  const value = unit === "kg" ? Number(lbValue) / LB_PER_KG : Number(lbValue);
  const fixed = Number.isFinite(value) ? value.toFixed(decimals) : "0";
  return opts.noUnit ? fixed : `${fixed} ${unit}`;
}

export function convertWeight(lbValue, prefs) {
  const unit = prefs?.weight_unit || "lb";
  return unit === "kg" ? Number(lbValue) / LB_PER_KG : Number(lbValue);
}

// User enters value in their chosen unit; convert to lb for storage.
export function toLbForStorage(displayValue, prefs) {
  const unit = prefs?.weight_unit || "lb";
  const v = Number(displayValue);
  if (!Number.isFinite(v)) return 0;
  return unit === "kg" ? v * LB_PER_KG : v;
}

// Temperature. The backend/weather API always returns Fahrenheit; render it in
// the user's preferred unit (default F). Pass noUnit to omit the °F/°C suffix.
export function formatTemp(fValue, prefs, opts = {}) {
  const unit = prefs?.temperature_unit || "F";
  const n = Number(fValue);
  if (fValue == null || Number.isNaN(n)) return opts.fallback ?? "—";
  const value = unit === "C" ? (n - 32) * 5 / 9 : n;
  const rounded = Math.round(value);
  return opts.noUnit ? `${rounded}` : `${rounded}°${unit}`;
}

// Just the unit suffix for the current preference, e.g. "°F".
export function tempUnitSuffix(prefs) {
  return `°${prefs?.temperature_unit || "F"}`;
}

const DATE_PATTERNS = {
  mdy: { date: "MMM d, yyyy", short: "MM/dd/yyyy", weekday: "EEE, MMM d, yyyy" },
  dmy: { date: "d MMM yyyy",   short: "dd/MM/yyyy", weekday: "EEE, d MMM yyyy"  },
  ymd: { date: "yyyy-MM-dd",   short: "yyyy-MM-dd", weekday: "EEE, yyyy-MM-dd"  },
};

export function formatDate(iso, prefs, variant = "date") {
  if (!iso) return "";
  const fmt = DATE_PATTERNS[prefs?.date_format || "mdy"]?.[variant] || "MMM d, yyyy";
  try {
    return dfFormat(parseISO(iso), fmt);
  } catch {
    return "";
  }
}

export function formatDateTime(iso, prefs) {
  if (!iso) return "";
  const dateFmt = DATE_PATTERNS[prefs?.date_format || "mdy"]?.weekday || "EEE, MMM d, yyyy";
  try {
    return dfFormat(parseISO(iso), `${dateFmt} · h:mm a`);
  } catch {
    return "";
  }
}

export const WEIGHT_UNIT_LABEL = { lb: "Pounds (lb)", kg: "Kilograms (kg)" };
export const TEMP_UNIT_LABEL = { F: "Fahrenheit (°F)", C: "Celsius (°C)" };
export const DATE_FORMAT_LABEL = {
  mdy: "MM/DD/YYYY (US)",
  dmy: "DD/MM/YYYY (EU)",
  ymd: "YYYY-MM-DD (ISO)",
};
